//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '3.8.5'.
//
package graphql.adapter

import com.apollographql.apollo3.api.Adapter
import com.apollographql.apollo3.api.CustomScalarAdapters
import com.apollographql.apollo3.api.NullableStringAdapter
import com.apollographql.apollo3.api.StringAdapter
import com.apollographql.apollo3.api.json.JsonReader
import com.apollographql.apollo3.api.json.JsonWriter
import com.apollographql.apollo3.api.list
import com.apollographql.apollo3.api.nullable
import com.apollographql.apollo3.api.obj
import graphql.GetAllTradeNewsQuery
import kotlin.String
import kotlin.Unit
import kotlin.collections.List

public object GetAllTradeNewsQuery_ResponseAdapter {
  public object Data : Adapter<GetAllTradeNewsQuery.Data> {
    public val RESPONSE_NAMES: List<String> = listOf("tradeNews")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        GetAllTradeNewsQuery.Data {
      var _tradeNews: List<GetAllTradeNewsQuery.TradeNew>? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _tradeNews = TradeNew.obj().list().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return GetAllTradeNewsQuery.Data(
        tradeNews = _tradeNews!!
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: GetAllTradeNewsQuery.Data,
    ): Unit {
      writer.name("tradeNews")
      TradeNew.obj().list().toJson(writer, customScalarAdapters, value.tradeNews)
    }
  }

  public object TradeNew : Adapter<GetAllTradeNewsQuery.TradeNew> {
    public val RESPONSE_NAMES: List<String> = listOf("id", "title", "description", "link", "source",
        "publishedAt", "category", "titleJa", "descriptionJa", "translationStatus", "translatedAt")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        GetAllTradeNewsQuery.TradeNew {
      var _id: String? = null
      var _title: String? = null
      var _description: String? = null
      var _link: String? = null
      var _source: String? = null
      var _publishedAt: String? = null
      var _category: String? = null
      var _titleJa: String? = null
      var _descriptionJa: String? = null
      var _translationStatus: String? = null
      var _translatedAt: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _id = StringAdapter.fromJson(reader, customScalarAdapters)
          1 -> _title = StringAdapter.fromJson(reader, customScalarAdapters)
          2 -> _description = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          3 -> _link = StringAdapter.fromJson(reader, customScalarAdapters)
          4 -> _source = StringAdapter.fromJson(reader, customScalarAdapters)
          5 -> _publishedAt = com.apollographql.apollo3.api.StringAdapter.fromJson(reader,
              customScalarAdapters)
          6 -> _category = StringAdapter.fromJson(reader, customScalarAdapters)
          7 -> _titleJa = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          8 -> _descriptionJa = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          9 -> _translationStatus = StringAdapter.fromJson(reader, customScalarAdapters)
          10 -> _translatedAt = com.apollographql.apollo3.api.StringAdapter.nullable().fromJson(reader,
              customScalarAdapters)
          else -> break
        }
      }

      return GetAllTradeNewsQuery.TradeNew(
        id = _id!!,
        title = _title!!,
        description = _description,
        link = _link!!,
        source = _source!!,
        publishedAt = _publishedAt!!,
        category = _category!!,
        titleJa = _titleJa,
        descriptionJa = _descriptionJa,
        translationStatus = _translationStatus!!,
        translatedAt = _translatedAt
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: GetAllTradeNewsQuery.TradeNew,
    ): Unit {
      writer.name("id")
      StringAdapter.toJson(writer, customScalarAdapters, value.id)

      writer.name("title")
      StringAdapter.toJson(writer, customScalarAdapters, value.title)

      writer.name("description")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.description)

      writer.name("link")
      StringAdapter.toJson(writer, customScalarAdapters, value.link)

      writer.name("source")
      StringAdapter.toJson(writer, customScalarAdapters, value.source)

      writer.name("publishedAt")
      com.apollographql.apollo3.api.StringAdapter.toJson(writer, customScalarAdapters,
          value.publishedAt)

      writer.name("category")
      StringAdapter.toJson(writer, customScalarAdapters, value.category)

      writer.name("titleJa")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.titleJa)

      writer.name("descriptionJa")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.descriptionJa)

      writer.name("translationStatus")
      StringAdapter.toJson(writer, customScalarAdapters, value.translationStatus)

      writer.name("translatedAt")
      com.apollographql.apollo3.api.StringAdapter.nullable().toJson(writer, customScalarAdapters,
          value.translatedAt)
    }
  }
}
